import React from 'react';
import {Card, Col, Row} from 'antd';
import {ArrowDownOutlined, ArrowUpOutlined} from '@ant-design/icons';

const ExpenseMonthlyCards = ({data}) => {
    const getTrendIndicator = (monthIndex) => {
        if (monthIndex === 0) return null;
        const current = data[monthIndex].total;
        const previous = data[monthIndex - 1].total;
        const diff = current - previous;
        const percent = previous > 0 ? (diff / previous) * 100 : 0;

        if (diff > 0) {
            return {
                value: `+${percent.toFixed(1)}%`,
                icon: <ArrowUpOutlined style={{color: '#ff4d4f'}}/>,
                color: '#ff4d4f'
            };
        } else if (diff < 0) {
            return {
                value: `${percent.toFixed(1)}%`,
                icon: <ArrowDownOutlined style={{color: '#52c41a'}}/>,
                color: '#52c41a'
            };
        }
        return null;
    };

    const getColorForAmount = (amount) => {
        if (amount === 0) return '#d9d9d9';
        if (amount < 1000) return '#52c41a';
        if (amount < 5000) return '#faad14';
        return '#ff4d4f';
    };

    return (
        <div>
            <h3>Расходы по месяцам</h3>
            <Row gutter={[16, 16]}>
                {data.map((monthData, index) => {
                    const trend = getTrendIndicator(index);
                    return (
                        <Col xs={24} sm={12} md={8} lg={6} key={monthData.month}>
                            <Card
                                title={monthData.month}
                                extra={trend && (
                                    <span style={{color: trend.color}}>
                    {trend.icon} {trend.value}
                  </span>
                                )}
                                size="small"
                                hoverable
                                style={{
                                    borderLeft: `4px solid ${getColorForAmount(monthData.total)}`,
                                    height: '100%'
                                }}
                            >
                                <div style={{
                                    fontSize: '18px',
                                    fontWeight: 'bold',
                                    color: getColorForAmount(monthData.total)
                                }}>
                                    {monthData.total.toLocaleString('ru-RU')} €
                                </div>

                                <div style={{marginTop: '15px', fontSize: '13px'}}>
                                    <div style={{marginBottom: '6px'}}>
                                        <span style={{color: '#666'}}>Зарплата: </span>
                                        <span
                                            style={{fontWeight: 'bold'}}>{monthData.salary.toLocaleString('ru-RU')} €</span>
                                    </div>

                                    <div style={{marginBottom: '6px'}}>
                                        <span style={{color: '#666'}}>Периодические: </span>
                                        <span
                                            style={{fontWeight: 'bold'}}>{monthData.periodic_expenses.toLocaleString('ru-RU')} €</span>
                                    </div>

                                    <div style={{marginBottom: '8px'}}>
                                        <span style={{color: '#666'}}>Разовые: </span>
                                        <span
                                            style={{fontWeight: 'bold'}}>{monthData.one_time_expenses.toLocaleString('ru-RU')} €</span>
                                    </div>
                                </div>
                            </Card>
                        </Col>
                    );
                })}
            </Row>
        </div>
    );
};

export default ExpenseMonthlyCards;